<script setup>

import { ref, computed } from 'vue';
import { FirebaseSignOut } from '../firebase_files/login';
import { store } from '@/store';
import router from '@/router';

function signUserOut() {
    FirebaseSignOut(); // signs user out
    store.user = null; // clear user data
    store.userRole = null;
    router.push({ name: 'login' });
}

const showUserBox = ref(false);
const userInitials = computed(() => {
    let userNames = store.user.displayName.split(' ');
    return userNames[0].substr(0, 1) + userNames.slice(-1)[0].substr(0, 1)
});

function onClickUser() {
    showUserBox.value = true;
    setTimeout(() => {
        window.addEventListener('click', closeUserBox);
    });
}
function closeUserBox() {
    showUserBox.value = false;
    window.removeEventListener('click', closeUserBox);
}
function openProfile(){
  router.push({name:'edit-account', params:{ newAct:'false'}})
 
}


</script>
<template>
    <div class="user" @click="onClickUser()">
        <i class="fa fa-user"></i> {{ store.user.displayName }}
    </div>
    <div class="user-box" v-if="showUserBox" @mouseleave="closeUserBox()">
        <div class="user-info">
            <div class="initials">{{ userInitials }}</div>
            <div class="info">
                <div class="name">{{ store.user.displayName }}</div>
                <div class="emnail">{{ store.user.email }}</div>
                <div class="link" @click="signUserOut">Logout</div>
                <div class="link" @click="openProfile">Edit Profile</div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
div.user {
    display: inline-block;
    margin: 10px 20px 0 0;
    padding: 10px 20px;
    border-radius: 10px;
    // background-color: #f4f4f4;
    color: #673ab7;
    cursor: pointer;
    border: solid 1px #fff;

    transition: all 0.3s ease;

    &:hover {
        border: solid 1px #673ab7;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
    }

    i {
        margin-right: 10px;
    }
}


div.user-box {
    position: absolute;
    min-width: 300px;
    top: 20px;
    right: 20px;
    padding: 20px;
    border-radius: 10px;
    border: solid 1px #ccc;
    background-color: #fff;
    text-align: left;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
    
    .user-info {
        display: flex;
    }
    .initials {
        display: inline-block;
        width: 44px;
        height: 44px;
        background-color: #bbb;
        color: #fff;
        border-radius: 22px;
        text-align: center;
        font-size: 22px;
        line-height: 44px;
    }

    .info {
        margin-left: 25px;
    }
    .name {
        font-size: 20px;
    }
    .email {
        font-size: 13px;
        color: #777;
    }

    .link {
        color: rgb(63, 140, 217);
        cursor: pointer;
        font-size: 15px;
        margin-top: 10px;
    }
}

</style>